import React from 'react';
import { toolkit } from '../mock';
import SectionHeader from './SectionHeader';

export default function Toolkit() {
  return (
    <section id="toolkit" className="py-20 md:py-28 border-t border-neutral-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          kicker={toolkit.kicker}
          title={toolkit.title}
          description={toolkit.description}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {toolkit.groups.map((g, idx) => (
            <div
              key={g.n}
              className={`p-7 md:p-9 border-neutral-900 ${
                idx % 3 !== 0 ? 'lg:border-l' : ''
              } ${idx % 2 !== 0 ? 'sm:border-l lg:border-l' : ''} ${
                idx >= 1 ? 'border-t sm:border-t' : ''
              } ${idx >= 2 ? 'lg:border-t' : 'lg:border-t-0'} ${idx >= 3 ? 'lg:border-t' : ''}`}
            >
              <p className="mono text-[11px] tracking-[0.22em] text-[#ED2D5C]">{g.n}</p>
              <h3 className="font-display text-white text-[26px] md:text-[30px] mt-3">{g.title}</h3>
              <ul className="mt-5 space-y-2">
                {g.items.map((it) => (
                  <li key={it} className="text-neutral-300 text-[14px] md:text-[15px]">
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
